module.exports = __webpack_public_path__ + "static/media/first-aid.1b303860.svg";